import React, { useEffect, useRef, useState } from 'react'
import { postGuardarConsentimientoInformadoUsuario, postInformacionEmpresa, postinsertOrUpdateFirmaConsentimiento } from '../../services/PaginaRuta';
import { fechaActual } from '../../hooks/UseDate';

const ModalFirmasDelConsentimientoInformado = ({setmodalOnFirmasConsentimientoInformado, dataUnConsentimientoInformado,tagFirma,setactualizarData,textAreaConsentimientoInformado,nombreQuienFirma}) => {
    
    const canvasRef = useRef(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const [loading, setloading]=useState(true)
  
    useEffect(() => {
      const canvas = canvasRef.current;
      const context = canvas.getContext('2d'); 
  
      const getCoordinates = (event) => {
        const rect = canvas.getBoundingClientRect();
        if (event.touches) {
          return {
            x: event.touches[0].clientX - rect.left,
            y: event.touches[0].clientY - rect.top,
          };
        } else {
          return {
            x: event.clientX - rect.left,
            y: event.clientY - rect.top,
          };
        }
      };
  
      const startDrawing = (event) => {
        setIsDrawing(true);
        const coords = getCoordinates(event);
        context.beginPath();
        context.moveTo(coords.x, coords.y);
      };
  
      const draw = (event) => {
        if (!isDrawing) return;
        const coords = getCoordinates(event);
        context.lineTo(coords.x, coords.y);
        context.stroke();
      };
  
      const stopDrawing = () => {
        setIsDrawing(false);
        context.closePath();
      };
  
      canvas.addEventListener('mousedown', startDrawing);
      canvas.addEventListener('mousemove', draw);
      canvas.addEventListener('mouseup', stopDrawing);
      canvas.addEventListener('mouseleave', stopDrawing);
  
      canvas.addEventListener('touchstart', startDrawing);
      canvas.addEventListener('touchmove', draw);
      canvas.addEventListener('touchend', stopDrawing);
  
      return () => {
        canvas.removeEventListener('mousedown', startDrawing);
        canvas.removeEventListener('mousemove', draw);
        canvas.removeEventListener('mouseup', stopDrawing);
        canvas.removeEventListener('mouseleave', stopDrawing);
  
        canvas.removeEventListener('touchstart', startDrawing);
        canvas.removeEventListener('touchmove', draw);
        canvas.removeEventListener('touchend', stopDrawing);
      };
    }, [isDrawing]);
  
    const clearCanvas = () => {
      const canvas = canvasRef.current;
      const context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
     
    };
  
    const saveSignature = () => {
      const canvas = canvasRef.current;
      const dataURL = canvas.toDataURL('image/png');
      

      const guardarConsentimiento={
        "codigo_consentimiento": dataUnConsentimientoInformado.codigo_consentimiento,
        "tipo_documento":dataUnConsentimientoInformado.tipo_documento,
        "numero_documento": dataUnConsentimientoInformado.numero_documento ,
        "nombre_paciente" :dataUnConsentimientoInformado.nombre_paciente ,
        "fecha": fechaActual(),
        "texto":textAreaConsentimientoInformado,
        "firma":dataURL,
        "tag":tagFirma,
        "nombre_consentimiento":dataUnConsentimientoInformado.nombre_consentimiento,
        "ProCirCod": dataUnConsentimientoInformado.ProCirCod,
        "idTbConsentimiento": dataUnConsentimientoInformado.id
      }

      setloading(false)
      postinsertOrUpdateFirmaConsentimiento(guardarConsentimiento).then((res)=>{ 
            setloading(true)
            setactualizarData(guardarConsentimiento)
            setmodalOnFirmasConsentimientoInformado(false)
        })
    };

    const handleCancelarClick=()=>{
        setmodalOnFirmasConsentimientoInformado(false)
    }

        

  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Captura de Firma
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
          <div>
        
        <canvas
          ref={canvasRef}
          width="630"
          height="200"
          style={{ border: '1px solid #000', touchAction: 'none' }}
        />
        
      </div>
          </div>
          <div className="flex justify-between items-center p-2 border-t border-gray-200 rounded-b-md">
          <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
          
            <div className="text-right ">
              <button
                type="button"
                onClick={clearCanvas}
                className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Limpiar
              </button>
              <button
                type="button"
                onClick={saveSignature}
                className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                {nombreQuienFirma}
              </button>
              
            </div>
          </div>
        </div>
      </div>
      {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            }
    </div>
  )
}

export default ModalFirmasDelConsentimientoInformado

